import Categories from './Categories.vue'

export default Categories
